var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('img',{staticStyle:{"width":"25px","height":"25px"},attrs:{"src":require("@/assets/image/logo.png"),"alt":"logo"}}),_c('span',[_vm._v("审批中心")])])
}]

export { render, staticRenderFns }